import axios from 'axios';
import { HomePagePopups } from './types';

export const save = (homePagePopups: HomePagePopups) => axios.put(
    // NOTE: This is an OWNER api, not an ADMIN api!
    '/api/pws/site-settings-section/current/homePagePopups',
    homePagePopups
);
